import { Stack } from '@festina-life/ui/structure'
import type { PropsWithChildren } from 'react'

import { DiffPresenceProvider } from '../../context/DiffPresenceProvider'

/**
 * The frame a comparison popover is read in. It draws no surface of its own,
 * so the popover it sits in provides the only border.
 *
 * Every popover is the same width regardless of what it compares, because a
 * reader stepping between two comparisons should not have the page resize under
 * them: how wide a comparison reads is a property of being a comparison
 * popover, not of the particular thing being compared.
 *
 * Every popover also keeps count of the diffed comparisons it draws, because
 * the control that chooses how they are laid out has no business appearing
 * beside a comparison that has none to lay out. Counting them is therefore part
 * of being a comparison popover rather than something each kind has to remember
 * to do: drawing one of these is what makes the count, so a popover cannot be
 * given a layout control it will never be able to answer for.
 */
export const DiffPopoverLayout = ({ children }: PropsWithChildren) => (
  <Stack className="min-w-300 max-w-(--breakpoint-2xl) flex-col overflow-x-auto">
    <DiffPresenceProvider>{children}</DiffPresenceProvider>
  </Stack>
)
